export default [
  {
    path: '/',
    name: 'accueil',
    component: () => import(/* webpackChunkName: "checklist" */ './views/Checklist.vue')
  },
  {
    path: '/home',
    name: 'checklist',
    component: () => import(/* webpackChunkName: "checklist" */ './views/Checklist.vue')
  },
  {
    path: '/price',
    name: 'cadencier',
    component: () => import(/* webpackChunkName: "cadencier" */ './views/Cadencier.vue')
  },
  {
    path: '/hygiene',
    name: 'hygiene',
    component: () => import(/* webpackChunkName: "hygiene" */ './views/Hygiene.vue')
  },
  {
    path: '/remarques',
    name: 'remarques',
    component: () => import(/* webpackChunkName: "hygiene" */ './views/Remarques.vue')
  },
  {
    path: '/recettes',
    name: 'recettes',
    component: () => import(/* webpackChunkName: "hygiene" */ './views/Recettes.vue')
  },
  {
    path: '/tracabilite',
    name: 'tracabilite',
    component: () => import(/* webpackChunkName: "tracabilite" */ './views/Tracabilite.vue')
  },
  {
    path: '/nettoyages',
    name: 'nettoyages',
    component: () => import(/* webpackChunkName: "nettoyages" */ './views/Nettoyages.vue')
  },
  {
    path: '/temperatures',
    name: 'temperatures',
    component: () => import(/* webpackChunkName: "temperatures" */ './views/Temperatures.vue')
  },
  {
    path: '/etiquettes',
    name: 'etiquettes',
    component: () => import(/* webpackChunkName: "commandes" */ './views/Etiquettes.vue')
  },
  {
    path: '/commandes',
    name: 'commandes',
    component: () => import(/* webpackChunkName: "commandes" */ './views/Commande.vue')
  },
  {
    path: '/backlog',
    name: 'backlog',
    component: () => import(/* webpackChunkName: "backlog" */ './views/Backlog.vue')
  },
  {
    path: '/achats',
    name: 'achats',
    component: () => import(/* webpackChunkName: "AchatsCore" */ './views/AchatsCore.vue')
  },
  {
    path: '/simulateur',
    name: 'achats',
    component: () => import(/* webpackChunkName: "Achats" */ './views/Simulateur.vue')
  },
  {
    path: '/tableauAchats',
    name: 'TableauAchats',
    component: () => import(/* webpackChunkName: "AchatsCore" */ './views/AchatsCore.vue')
  },
  {
    path: '/fournisseurs',
    name: 'Fournisseurs',
    component: () => import(/* webpackChunkName: "Fournisseurs" */ './views/Fournisseurs.vue')
  },
  {
    path: '/objectifs',
    name: 'Objectifs',
    component: () => import(/* webpackChunkName: "Objectifs" */ './views/Objectifs.vue')
  },
  {
    path: '/integration',
    name: 'integration',
    component: () => import(/* webpackChunkName: "Integration" */ './views/Integration.vue')
  },
  {
    path: '/integration/rules',
    name: 'integration-rules',
    component: () => import(/* webpackChunkName: "IntegrationRules" */ './views/IntegrationRules.vue')
  },
  {
    path: '/mail',
    name: 'mail',
    component: () => import(/* webpackChunkName: "Integration" */ './views/Mail.vue')
  },
  {
    path: '/config',
    name: 'settings',
    component: () => import(/* webpackChunkName: "Integration" */ './views/Settings.vue')
  },
  {
    path: '/plateau',
    name: 'plateau',
    component: () => import(/* webpackChunkName: "Integration" */ './views/Plateau.vue')
  },
  {
    path: '/rendements',
    name: 'rendements',
    component: () => import(/* webpackChunkName: "rendements" */ './views/Rendements.vue')
  },
  {path: '*', redirect: '/'}
  // {
  //   path: '/fournisseur',
  //   name: 'fournisseur',
  //   component: () => import(/* webpackChunkName: "commandes" */ './views/Fournisseur.vue'),
  // },
]
